var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgService7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.916,
    y: 65.816,
    style: {
      fill: "#F0F0F0"
    },
    width: 65.307,
    height: 12.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.652,
    y: 78.515,
    style: {
      fill: "#E0E0E0"
    },
    width: 55.835,
    height: 6.515
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.453,
    y: 85.03,
    style: {
      fill: "#F0F0F0"
    },
    width: 44.232,
    height: 290.784
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.866,
    y: 85.03,
    style: {
      fill: "#E0E0E0"
    },
    width: 33.408,
    height: 290.784
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.755,
    y: 85.03,
    style: {
      fill: "#F0F0F0"
    },
    width: 13.629,
    height: 290.784
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 350.916,
    y: 382.33,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 767.1393 777.3589)",
    style: {
      fill: "#F0F0F0"
    },
    width: 65.307,
    height: 12.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.652,
    y: 375.815,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 767.1393 758.1445)",
    style: {
      fill: "#E0E0E0"
    },
    width: 55.835,
    height: 6.515
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.777,
    y: 65.816,
    style: {
      fill: "#F0F0F0"
    },
    width: 65.307,
    height: 12.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.513,
    y: 78.515,
    style: {
      fill: "#E0E0E0"
    },
    width: 55.835,
    height: 6.515
  })), /*#__PURE__*/React.createElement("rect", {
    x: 94.314,
    y: 85.03,
    style: {
      fill: "#F0F0F0"
    },
    width: 44.232,
    height: 290.784
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.726,
    y: 85.03,
    style: {
      fill: "#E0E0E0"
    },
    width: 33.408,
    height: 290.784
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.616,
    y: 85.03,
    style: {
      fill: "#F0F0F0"
    },
    width: 13.629,
    height: 290.784
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 83.777,
    y: 382.33,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 232.8607 777.3589)",
    style: {
      fill: "#F0F0F0"
    },
    width: 65.307,
    height: 12.699
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.513,
    y: 375.815,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 232.8607 758.1445)",
    style: {
      fill: "#E0E0E0"
    },
    width: 55.835,
    height: 6.515
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Background_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M138.5,86.56c53.104-23.955,90.384,33.786,100.442,74.23s34.924,51.773,57.806,37.357 c22.882-14.416,61.857-74.391,111.054-24.978S388.734,345.562,283.534,358.81C224.687,366.221,140,340.645,110.321,242.339 C92.636,183.763,96.007,105.728,138.5,86.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M138.5,86.56c53.104-23.955,90.384,33.786,100.442,74.23 s34.924,51.773,57.806,37.357c22.882-14.416,61.857-74.391,111.054-24.978S388.734,345.562,283.534,358.81 C224.687,366.221,140,340.645,110.321,242.339C92.636,183.763,96.007,105.728,138.5,86.56z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Character_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M289.997,125.517c0,0-5.713-1.611-21.069,0.615c0,0,0.427,24.856,3.019,37.342 c0,0,8.491,0.989,17.405-0.939C289.353,162.535,286.394,134.505,289.997,125.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1
    },
    d: "M289.997,125.517c0,0-5.713-1.611-21.069,0.615c0,0,0.427,24.856,3.019,37.342 c0,0,8.491,0.989,17.405-0.939C289.353,162.535,286.394,134.505,289.997,125.517z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M272.893,182.155l-3.8-15.259c0,0-4.187-2.51-4.53-5.29c-0.343-2.78,4.086-10.564,4.95-10.554 c0.864,0.01,6.469,4.203,6.455,5.437c-0.014,1.234-1.121,7.86-1.121,7.86l7.629,14.792L272.893,182.155z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "270.52,176.465 268.331,171.345 279.123,165.071 282.477,170.768  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "270.52,176.465 268.331,171.345  279.123,165.071 282.477,170.768  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M319.75,158.497c-6.48,4.302-20.872,25.241-24.426,24.937 c-4.607-0.394-12.235-15.828-12.235-15.828l-14.16,8.534c0,0,16.581,33.483,25.828,31.375 c9.247-2.108,26.782-27.79,27.974-31.576C323.923,172.151,327.787,153.161,319.75,158.497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M319.75,158.497c-6.48,4.302-20.872,25.241-24.426,24.937 c-4.607-0.394-12.235-15.828-12.235-15.828l-14.16,8.534c0,0,16.581,33.483,25.828,31.375 c9.247-2.108,26.782-27.79,27.974-31.576C323.923,172.151,327.787,153.161,319.75,158.497z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2877B"
    },
    points: "317.532,407.609 309.419,408.466 307.896,390.969 316.009,390.112  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E2877B"
    },
    points: "358.011,407.018 350.151,407.018 349.501,388.808 357.371,388.808  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M349.061,406.108h9.55c0.322,0.002,0.6,0.226,0.67,0.54l1.55,7 c0.133,0.627-0.268,1.242-0.895,1.375c-0.084,0.018-0.169,0.026-0.255,0.025c-3.09-0.05-5.34-0.24-9.22-0.24 c-2.39,0-9.6,0.25-12.9,0.25c-3.3,0-3.73-3.26-2.38-3.56c6.06-1.32,10.62-3.15,12.56-4.89 C348.1,406.278,348.573,406.099,349.061,406.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M346.461,407.488c-0.534,0.043-1.067-0.098-1.51-0.4c-0.295-0.243-0.443-0.622-0.39-1 c-0.006-0.221,0.12-0.425,0.32-0.52c0.87-0.45,3.41,1.11,3.69,1.29c0.066,0.034,0.103,0.107,0.09,0.18 c-0.01,0.077-0.065,0.14-0.14,0.16C347.847,407.371,347.156,407.468,346.461,407.488z M345.291,405.858 c-0.083-0.007-0.167,0.01-0.24,0.05c-0.05,0-0.11,0.07-0.12,0.22c-0.032,0.251,0.062,0.501,0.25,0.67 c0.882,0.4,1.883,0.45,2.8,0.14C347.161,406.409,346.248,406.043,345.291,405.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M348.471,407.208h-0.09c-0.81-0.44-2.38-2.17-2.22-3c0.057-0.286,0.309-0.491,0.6-0.49 c0.286-0.038,0.573,0.05,0.79,0.24c0.91,0.74,1.1,3,1.11,3.11c0.001,0.068-0.033,0.133-0.09,0.17 C348.535,407.239,348.5,407.228,348.471,407.208z M346.891,404.018h-0.09c-0.24,0-0.26,0.14-0.27,0.19 c-0.1,0.51,0.9,1.82,1.71,2.43c-0.053-0.896-0.377-1.754-0.93-2.46C347.195,404.076,347.046,404.019,346.891,404.018z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M308.561,405.858h9.55c0.322,0.002,0.6,0.226,0.67,0.54l1.55,7 c0.133,0.627-0.268,1.242-0.895,1.375c-0.084,0.018-0.169,0.026-0.255,0.025c-3.09-0.05-5.34-0.24-9.22-0.24 c-2.39,0-9.6,0.25-12.9,0.25c-3.3,0-3.73-3.26-2.38-3.56c6.06-1.32,10.62-3.15,12.56-4.89 C307.6,406.028,308.073,405.849,308.561,405.858z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M305.961,407.238c-0.534,0.043-1.067-0.098-1.51-0.4c-0.295-0.243-0.443-0.622-0.39-1 c-0.006-0.221,0.12-0.425,0.32-0.52c0.87-0.45,3.41,1.11,3.69,1.29c0.066,0.034,0.103,0.107,0.09,0.18 c-0.01,0.077-0.065,0.14-0.14,0.16C307.347,407.121,306.656,407.218,305.961,407.238z M304.791,405.608 c-0.083-0.007-0.167,0.01-0.24,0.05c-0.05,0-0.11,0.07-0.12,0.22c-0.032,0.251,0.062,0.501,0.25,0.67 c0.882,0.4,1.883,0.45,2.8,0.14C306.661,406.159,305.748,405.793,304.791,405.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M307.971,406.958h-0.09c-0.81-0.44-2.38-2.17-2.22-3c0.057-0.286,0.309-0.491,0.6-0.49 c0.286-0.038,0.573,0.05,0.79,0.24c0.91,0.74,1.1,3,1.11,3.11c0.001,0.068-0.033,0.133-0.09,0.17 C308.035,406.989,308,406.978,307.971,406.958z M306.391,403.768h-0.09c-0.24,0-0.26,0.14-0.27,0.19 c-0.1,0.51,0.9,1.82,1.71,2.43c-0.053-0.896-0.377-1.754-0.93-2.46C306.695,403.826,306.546,403.769,306.391,403.768z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "357.371,388.818 349.501,388.818 349.841,398.208  357.711,398.208  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.125,229.081h-41.724c-3.967,21.663-15.838,104.917-6.929,173.222l14.125-1.751 c0,0-1.854-97.271,10.617-130.794c1.434,17.941,3.138,37.03,4.617,47.187c3.63,25,11.735,84.216,11.735,84.216h14.38 c0,0-3.275-56.876-4.635-81.446C354.824,293.04,354.183,234.559,354.125,229.081z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M354.125,229.081h-41.724c-3.967,21.663-15.838,104.917-6.929,173.222l14.125-1.751c0,0-1.854-97.271,10.617-130.794 c1.434,17.941,3.138,37.03,4.617,47.187c3.63,25,11.735,84.216,11.735,84.216h14.38c0,0-3.275-56.876-4.635-81.446 C354.824,293.04,354.183,234.559,354.125,229.081z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      enableBackground: "new"
    },
    d: "M310.72,239.157c0,0,12.295,2.848,20.869,0l-0.77-6.665l-19.952,0.037 L310.72,239.157z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M316.914,240.127c2.342,0.242,5.118,0.391,7.916,0.224v-7.847l-7.916,0.015V240.127 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M330.211,269.761c-1.84,4.94-3.37,11.11-4.66,18.05 c-1.167-15.965,3.5-32.897,3.5-32.897L330.211,269.761z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.626,134.021c0,0-0.31,7.661-6.278,5.856C336.38,138.073,343.356,131.287,348.626,134.021z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M330.82,153.161c0,0,4.066-2.779,2.747-8.411l10.801-8.714c0,0-1.401,10.699,1.208,16.357 c0,0-6.515,6.605-11.486,5.098C329.118,155.984,330.82,153.161,330.82,153.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M341.94,141.263l-4.272,0.178l-4.101,3.309 c0.411,1.755,0.299,3.232-0.05,4.435C340.056,148.127,341.94,141.263,341.94,141.263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M341.663,160.877l-8.947-3.386l-7.506,0.555c0,0-7.941,18.107-10.883,36.793 s-3.009,39.26-3.009,39.26c0.273-0.061,11.01,2.294,20.947-1.087c0,0-6.621-28.009-3.046-40.828 c3.574-12.819,12.344-31.307,12.344-31.307"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M341.663,160.877l-8.947-3.386l-7.506,0.555 c0,0-7.941,18.107-10.883,36.793s-3.009,39.26-3.009,39.26c0.273-0.061,11.01,2.294,20.947-1.087c0,0-6.621-28.009-3.046-40.828 c3.574-12.819,12.344-31.307,12.344-31.307"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.4,
      enableBackground: "new"
    },
    d: "M329.219,157.749l0.538,4.923c0,0-6.643,12.932-9.016,21.577 c-2.374,8.645-4.287,34.884-4.287,34.884l4.159,7.15l3.82-7.15c0,0-0.972-21.031,2.059-35.164 c3.031-14.133,4.749-20.522,4.749-20.522l4.603-3.326l-3.127-2.63L329.219,157.749z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "330.82,153.161 333.898,156.215 345.576,152.393 336.871,165.267 332.557,158.354  325.538,160.344  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M330.82,153.161c0,0-16.069,3.506-19.502,17.983c-3.432,14.477-5.448,77.768-5.947,82.867 c-0.499,5.099,9.568,5.73,9.568,5.73s-0.541-32.733,0.285-41.42c0.299-3.143,0.753-13.743,2.178-22.011 C319.915,181.725,324.275,162.923,330.82,153.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M327.492,154.326c-2.184,1.924-7.391,6.02-10.018,10.318l4.058,2.143l-5.551,3.534 c0,0,0.463,15.587,1.815,23.762c2.563-14.224,6.806-31.648,13.023-40.922C330.82,153.161,329.495,153.527,327.492,154.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M327.492,154.326c-2.184,1.924-7.391,6.02-10.018,10.318 l4.058,2.143l-5.551,3.534c0,0,0.463,15.587,1.815,23.762c2.563-14.224,6.806-31.648,13.023-40.922 C330.82,153.161,329.495,153.527,327.492,154.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M318.513,119.602c0,0-0.565,5.88,4.03,7.189c0,0,2.612-6.567-0.56-7.189 C318.81,118.98,318.513,119.602,318.513,119.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M322.464,136.158c0.723,4.161,3.846,12.881,12.672,10.22c8.826-2.66,9.205-9.624,9.353-11.635 c0.148-2.01-1.724-17.619-7.371-19.101c-5.647-1.482-12.499,0.349-14.654,3.575 C320.309,122.444,322.464,136.158,322.464,136.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M343.98,129.708c0.143,0.186-5.842,3.759-5.653-8.612c0,0-4.324,1.841-5.325-3.069 c0,0-18.102,6.247-16.3-0.793c2.408-9.406,17.049-10.113,23.355-5.195c0,0,3.135-3.505,6.086,0.275 c3.525,4.516,3.469,16.764,3.469,16.764L343.98,129.708z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M348.502,128.12c-2.118-3.329-11.594,0.165-13.428,0.881l-0.063-0.469c-0.046-0.345-0.236-0.657-0.522-0.856 c-0.285-0.2-0.641-0.272-0.983-0.198l-3.885,0.843c-0.649,0.141-1.075,0.763-0.97,1.417c0.02,0.123,0.045,0.271,0.068,0.407 c-0.777-0.288-1.448-0.045-1.887,0.269l-0.047-0.324c-0.048-0.332-0.222-0.624-0.491-0.824c-0.268-0.2-0.599-0.281-0.931-0.233 l-3.272,0.488c-0.65,0.097-1.117,0.684-1.061,1.338c0.06,0.718,0.129,1.343,0.204,1.855c0.048,0.33,0.223,0.62,0.492,0.818 c0.217,0.16,0.475,0.243,0.74,0.243c0.061,0,0.124-0.004,0.186-0.013l3.333-0.489c0.681-0.1,1.155-0.735,1.056-1.416 l-0.124-0.861c0.219-0.216,0.938-0.785,1.907-0.241c0.048,0.272,0.098,0.548,0.149,0.81c0.064,0.327,0.252,0.609,0.53,0.794 c0.208,0.139,0.448,0.211,0.692,0.211c0.085,0,0.17-0.009,0.255-0.026l3.821-0.786c0.641-0.131,1.075-0.743,0.987-1.392 l-0.115-0.854c1.419-0.554,11.008-4.156,12.938-1.123c0.075,0.117,0.23,0.151,0.345,0.077 C348.542,128.391,348.576,128.236,348.502,128.12z M325.913,132.775l-3.333,0.489c-0.198,0.029-0.396-0.021-0.557-0.138 c-0.161-0.118-0.265-0.291-0.293-0.487c-0.073-0.503-0.141-1.116-0.201-1.825c-0.033-0.392,0.247-0.744,0.637-0.802l3.272-0.488 c0.038-0.005,0.075-0.008,0.112-0.008c0.16,0,0.315,0.051,0.446,0.149c0.161,0.12,0.266,0.295,0.294,0.494l0.256,1.767 C326.605,132.335,326.321,132.716,325.913,132.775z M334.17,131.267l-3.821,0.786c-0.201,0.042-0.402,0.001-0.57-0.111 c-0.166-0.11-0.278-0.279-0.317-0.474c-0.118-0.605-0.232-1.281-0.317-1.81c-0.063-0.392,0.192-0.765,0.582-0.849l3.885-0.843 c0.054-0.012,0.108-0.018,0.162-0.018c0.152,0,0.299,0.046,0.427,0.136c0.174,0.122,0.285,0.304,0.313,0.515l0.248,1.833 C334.815,130.821,334.555,131.188,334.17,131.267z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M332.652,129.779c0.149,0.612-0.133,1.185-0.548,1.255c-0.415,0.07-0.825-0.386-0.935-1.007 c-0.11-0.622,0.143-1.188,0.548-1.255C332.123,128.703,332.54,129.147,332.652,129.779z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M324.89,130.985c0.149,0.612-0.143,1.188-0.549,1.255c-0.405,0.068-0.825-0.386-0.935-1.007 c-0.11-0.621,0.143-1.188,0.548-1.255C324.361,129.91,324.787,130.392,324.89,130.985z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC5753"
    },
    d: "M327.884,130.909c-0.418,2.038-1.115,4.009-2.073,5.857c0.975,0.473,2.11,0.49,3.099,0.048 L327.884,130.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M334.012,126.065c-0.087,0.108-0.226,0.161-0.363,0.14c-0.928-0.185-1.89,0.079-2.593,0.713 c-0.139,0.15-0.373,0.159-0.523,0.02c-0.15-0.139-0.158-0.373-0.019-0.523c0,0,0.001-0.001,0.001-0.001 c0.869-0.824,2.083-1.174,3.257-0.941c0.202,0.029,0.343,0.217,0.313,0.419c0,0.003-0.001,0.006-0.001,0.009 C334.069,125.958,334.044,126.014,334.012,126.065z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M330.479,139.876L330.479,139.876c1.862-0.035,3.59-0.975,4.63-2.52 c0.054-0.094,0.023-0.214-0.07-0.27c-0.088-0.057-0.206-0.031-0.262,0.057c-0.003,0.004-0.005,0.008-0.008,0.013 c-0.991,1.409-2.588,2.269-4.31,2.32c-0.105-0.001-0.19,0.084-0.191,0.189c0,0.007,0,0.014,0.001,0.021 c-0.001,0.105,0.084,0.19,0.189,0.191C330.465,139.878,330.472,139.877,330.479,139.876z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M322.217,127.185c-0.07-0.026-0.131-0.074-0.172-0.136c-0.079-0.189,0.011-0.405,0.199-0.484 c0.003-0.001,0.005-0.002,0.008-0.003c1.105-0.47,2.37-0.373,3.39,0.26c0.167,0.118,0.207,0.349,0.089,0.516 c0,0,0,0.001,0,0.001c-0.121,0.163-0.348,0.202-0.517,0.089l0,0c-0.82-0.477-1.817-0.537-2.689-0.164 C322.416,127.283,322.303,127.255,322.217,127.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M345.575,152.393c0,0,10.698,6.237,16.219,8.579c5.521,2.342-2.859,40.428-3.061,46.98 c-0.203,6.552,5.756,51.695,5.756,51.695s-17.042,4.432-30.927,1.128c0,0-9.841-37.54-8.627-57.214 C326.102,184.636,331.78,165.992,345.575,152.393z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M349.952,154.905c-2.532-1.421-4.376-2.512-4.376-2.512 c-13.343,13.153-19.079,31.026-20.499,49.307c5.786-14.112,19.249-27.041,19.249-27.041l-4.155-6.088l7.626-0.601 C347.907,162.496,349.197,157.429,349.952,154.905z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M349.952,154.905c-2.532-1.421-4.376-2.512-4.376-2.512 c-13.343,13.153-19.079,31.026-20.499,49.307c5.786-14.112,19.249-27.041,19.249-27.041l-4.155-6.088l7.626-0.601 C347.907,162.496,349.197,157.429,349.952,154.905z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M345.382,177.309c-0.015-0.18-0.178-0.312-0.364-0.297l-24.035,2.024v1.685h-2.528 l3.221,38.824c0.015,0.18,0.126,0.181,0.138,0.316l0.262-0.022l0.21-0.3l0.797-0.067l0.263,0.26l25.043-2.109 c0.186-0.016,0.325-0.174,0.31-0.354L345.382,177.309z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_25_",
    style: {
      fill: "#407BFF"
    },
    d: "M319.416,216.898c0.188,2.236,2.141,2.985,2.393,2.964 c-0.173-2.05-0.41-4.007-0.41-4.007s-2.188-29.781-2.757-36.616c-0.686-0.033-2.298,1.182-2.182,2.556 c0.078,0.926,0.237,2.811,0.237,2.811S318.791,209.478,319.416,216.898z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_24_",
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M319.416,216.898 c0.188,2.236,2.141,2.985,2.393,2.964c-0.173-2.05-0.41-4.007-0.41-4.007s-2.188-29.781-2.757-36.616 c-0.686-0.033-2.298,1.182-2.182,2.556c0.078,0.926,0.237,2.811,0.237,2.811S318.791,209.478,319.416,216.898z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    style: {
      fill: "#407BFF"
    },
    d: "M321.82,219.003l25.88-2.099l-1.499-4.439l-24.757,2.085 c0,0-1.23,0.463-1.072,2.333C320.509,218.493,321.82,219.003,321.82,219.003z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_22_",
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M321.82,219.003l25.88-2.099l-1.499-4.439l-24.757,2.085 c0,0-1.23,0.463-1.072,2.333C320.509,218.493,321.82,219.003,321.82,219.003z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21_",
    style: {
      fill: "#407BFF"
    },
    d: "M347.241,212.517l-24.446,2.059l-0.187-0.124l-0.755,0.064l-0.166,0.154 l-0.321,0.027c-0.036,0.003-0.067-0.023-0.07-0.059l-2.973-35.306c-0.003-0.036,0.023-0.067,0.059-0.07l0.365-0.031 l0.157,0.27l0.755-0.062l0.185-0.301l24.412-2.056c0.036-0.003,0.067,0.023,0.07,0.059l2.974,35.306 C347.303,212.482,347.277,212.514,347.241,212.517z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M341.639,197.125l-17.167,1.446l-1.218-14.464 l17.167-1.446L341.639,197.125z M325.282,197.494l15.379-1.295l-1.049-12.462l-15.379,1.295L325.282,197.494z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M316.907,187.11c0,0,0.393-1.767,1.88-2.265 c0.023,0.271,0.048,0.389,0.095,1.122c-1.495,0.938-1.851,2.606-1.851,2.606L316.907,187.11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M318.762,209.138c0,0,0.393-1.767,1.88-2.265 c0.023,0.271,0.048,0.389,0.095,1.122c-1.495,0.938-1.851,2.606-1.851,2.606L318.762,209.138z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_15_",
    x: 320.378,
    y: 179.409,
    transform: "matrix(0.9965 -0.0839 0.0839 0.9965 -15.4005 27.6161)",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    width: 0.758,
    height: 35.137
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_14_",
    x: 327.478,
    y: 201.959,
    transform: "matrix(0.9965 -0.0839 0.0839 0.9965 -15.8426 28.7061)",
    style: {
      fill: "#407BFF"
    },
    width: 12.087,
    height: 1.667
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_13_",
    x: 330.448,
    y: 205.59,
    transform: "matrix(0.9965 -0.0839 0.0839 0.9965 -16.1476 28.7472)",
    style: {
      fill: "#407BFF"
    },
    width: 6.759,
    height: 1.667
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M321.779,216.492l23.139-1.949 c0,0-7.044,0.458-15.765,1.192C325.45,216.047,321.779,216.492,321.779,216.492z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M321.855,217.393l23.193-2.163 c0,0-7.104,0.598-15.825,1.333C325.52,216.874,321.855,217.393,321.855,217.393z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M321.923,218.195l23.311-2.173 c0,0-7.223,0.608-15.944,1.343C325.588,217.677,321.923,218.195,321.923,218.195z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    style: {
      fill: "#407BFF"
    },
    d: "M326.515,215.22c0.202,2.397,0.383,4.548,0.383,4.548l-1.631-1.525l-1.353,1.777 c0,0-0.095-1.123-0.388-4.603C324.426,215.323,325.791,215.281,326.515,215.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M326.515,215.22c0.202,2.397,0.383,4.548,0.383,4.548 l-1.631-1.525l-1.353,1.777c0,0-0.095-1.123-0.388-4.603C324.426,215.323,325.791,215.281,326.515,215.22z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M321.706,215.625l23.411-1.836 c0,0-7.317,0.346-16.038,1.08C325.378,215.181,321.706,215.625,321.706,215.625z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    style: {
      fill: "#407BFF"
    },
    d: "M347.306,212.511l-1.365,0.115c0,0-0.481,0.823-0.082,2.18 c0.536,1.825,1.811,2.02,1.811,2.02L347.306,212.511z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M340.456,214.796l-14.276-6.594c0,0-4.579,1.692-6.961,0.218 c-2.382-1.474-5.676-9.802-5.128-10.469c0.549-0.667,7.328-2.411,8.281-1.628c0.953,0.783,5.426,5.796,5.426,5.796 l16.309,3.317L340.456,214.796z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "336.473,200.908 330.752,200.567 331.355,213.435 337.435,214.462  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#407BFF"
    },
    points: "336.473,200.908 330.752,200.567 331.355,213.435 337.435,214.462  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.8,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "336.473,200.908 330.752,200.567  331.355,213.435 337.435,214.462  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.882,159.682c9.547,1.02,13.388,15.409,14.719,22.609 c1.297,7.019,4.837,28.886-3.212,34.801c-8.049,5.915-33.568-0.573-33.568-0.573l-1.36-17.55c0,0,13.707,3.095,19.633,0.792 c4.96-1.928,2.663-19.765,2.144-22.961C355.498,172.243,353.394,159.203,357.882,159.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M357.882,159.682c9.547,1.02,13.388,15.409,14.719,22.609 c1.297,7.019,4.837,28.886-3.212,34.801c-8.049,5.915-33.568-0.573-33.568-0.573l-1.36-17.55c0,0,13.707,3.095,19.633,0.792 c4.96-1.928,2.663-19.765,2.144-22.961C355.498,172.243,353.394,159.203,357.882,159.682z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M342.105,130.665c0,0,1.576-4.365,5.611-4.383c3.245-0.015,3.713,4.045,2.235,6.849 c-1.133,2.15-4.838,4.838-7.2,2.023C340.391,132.339,342.105,130.665,342.105,130.665z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Character_1_1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#457BFB"
    },
    points: "145.379,329.058 145.019,344.628 143.379,415.058 137.969,415.058 136.339,344.628  135.979,329.058  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "145.379,329.058 145.019,344.628  143.379,415.058 137.969,415.058 136.339,344.628 135.979,329.058  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "145.379,329.058 145.019,345.058 136.339,345.058  135.979,329.058  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#457BFB"
    },
    points: "174.757,414.808 169.76,330.158 161.59,330.158 168.587,414.808  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "168.572,414.808 174.748,414.808  170.213,337.758 169.763,330.058 161.593,330.058 162.223,337.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "161.593,330.058 162.223,338.058 170.213,338.058  169.763,330.058  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#457BFB"
    },
    points: "112.766,414.808 119.763,330.158 111.593,330.158 106.596,414.808  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "112.781,414.808 119.13,337.758  119.76,330.058 111.59,330.058 111.14,337.758 106.604,414.808  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "119.76,330.058 119.13,338.058 111.14,338.058  111.59,330.058  "
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.137,321.391h-56.921c-2.761,0-5,2.239-5,5v6.689h66.921v-6.689C174.137,323.63,171.898,321.391,169.137,321.391z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#457BFB"
    },
    d: "M175.332,327.236h-69.311c-1.111,0-2.011,0.901-2.011,2.011v1.822 c0,1.111,0.9,2.011,2.011,2.011h69.311c1.111,0,2.011-0.901,2.011-2.011v-1.822 C177.343,328.136,176.443,327.236,175.332,327.236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M175.332,327.236h-69.311 c-1.111,0-2.011,0.901-2.011,2.011v1.822c0,1.111,0.9,2.011,2.011,2.011h69.311c1.111,0,2.011-0.901,2.011-2.011v-1.822 C177.343,328.136,176.443,327.236,175.332,327.236z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__1_"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9B076"
    },
    d: "M176.875,245.661c0,0,20.143,20.895,21.362,21.98c1.219,1.085,8.734,3.517,9.839,4.478 c1.105,0.961-0.755,8.01-1.497,9.353c-0.742,1.342-11.357-4.456-12.005-5.398c-0.648-0.942-1.507-3.687-1.507-3.687 l-22.855-19.198L176.875,245.661z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M159.905,225.434c0,0,0.066,0.807,0.222,2.148c0.152,1.392,0.403,3.361,0.765,5.601 c0.872,5.443,2.386,12.457,4.827,16.697c0.721,1.249,1.519,2.26,2.407,2.913c3.2,2.376,17.335,17.929,17.335,17.929l7.513-9.556 l-9.959-12.618c0,0-6.576-37.167-16.604-40.065C162.051,207.222,159.905,225.434,159.905,225.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M159.905,225.434c0,0,0.066,0.807,0.222,2.148c0.152,1.392,0.403,3.361,0.765,5.601 c0.872,5.443,2.386,12.457,4.827,16.697c0.721,1.249,1.519,2.26,2.407,2.913c3.2,2.376,17.335,17.929,17.335,17.929l7.513-9.556 l-9.959-12.618c0,0-6.576-37.167-16.604-40.065C162.051,207.222,159.905,225.434,159.905,225.434z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9B076"
    },
    points: "169.022,407.837 176.988,406.744 178.092,387.808 170.138,388.91  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "170.138,388.91 178.094,387.818 177.46,398.642  169.515,399.339  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M169.342,296.518l-1.944-12.176l-44.66-2.671c0,0-4.749,25.337-1.1,32.087 c6.514,12.051,41.618,5.969,51.89,7.154c-6.14,25.11-5.54,74.18-5.54,74.18l14.67,1.12c0,0,11.288-52.876,13.57-78 C197.768,301.259,183.721,301.681,169.342,296.518z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#457BFB"
    },
    points: "166.268,395.783 183.898,396.943 185.408,389.393 166.038,388.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E9B076"
    },
    points: "187.399,400.766 195.418,401.356 200.442,383.065 192.433,382.486  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M196.533,401.713c0.01,0.02,0.006,0.046,0.022,0.062c0.02,0.011,0.045,0.012,0.068,0.009 c0.622,0.35,1.279,0.633,1.962,0.842c0.498,0.203,1.055,0.212,1.56,0.025c0.336-0.191,0.533-0.559,0.503-0.945 c0.023-0.243-0.078-0.48-0.271-0.629c-0.455-0.339-1.408-0.239-2.248-0.061c0.612-0.499,1.149-1.126,1.184-1.627 c0.019-0.329-0.17-0.63-0.485-0.728c-0.272-0.113-0.544-0.1-0.805,0.035c-0.974,0.535-1.352,2.779-1.381,2.899 c0,0.001,0.142,0.001,0.142,0.002c0,0.001,0,0.001,0,0.002s-0.144,0.007-0.144,0.008c-0.001,0.008-0.135,0.014-0.135,0.023 C196.505,401.66,196.514,401.689,196.533,401.713z M197.131,401.267c-0.067,0.02-0.124,0.038-0.18,0.055 c0.188-0.738,0.592-1.95,1.175-2.262c0.129-0.078,0.285-0.099,0.43-0.057l0.087,0.031c0.249,0.102,0.281,0.247,0.268,0.356 C198.842,399.932,197.921,400.832,197.131,401.267z M197.161,401.68c1.058-0.32,2.526-0.609,2.977-0.27 c0.096,0.073,0.146,0.19,0.133,0.309c0.011,0.242-0.106,0.472-0.308,0.606C199.497,402.579,198.469,402.339,197.161,401.68z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "192.433,382.486 200.441,383.075 197.568,393.529  189.651,392.557  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M203.159,392.239l-14.12-4.15c0,0,8.43-47.58,16.98-64.08c-0.64-0.21-1.49-0.48-2.54-0.79 c-1.89-0.57-4.4-1.28-7.35-2.1c-20.52-5.69-62.11-16.36-62.11-16.36l19-17.73c0,0,75.68,11.54,77.25,31.48 C231.018,328.099,203.159,392.239,203.159,392.239z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#457BFB"
    },
    points: "187.217,388.402 204.218,393.209 207.268,386.139 188.51,381.224  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M203.479,323.219c-1.89-0.57-4.4-1.28-7.35-2.1 c0.59-4.84,0.6-10.39-1.73-13.22c-4.63-5.64-16.54-8.95-23.32-10.15c-5.67-1-24.72-2.99-24.72-2.99s24.72-2.37,49.99,5 C208.839,303.409,206.409,315.619,203.479,323.219z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M120.26,294.396c-2.976-2.284-0.118-23.586-1.649-44.542 c-2.329-31.895,2.677-42.287,5.029-43.28c4.337-0.753,6.049-1.044,10.449-1.156c6.441-0.233,12.889-0.094,19.314,0.417 c4.398,0.542,8.748,1.427,13.008,2.648c0,0,10.524,33.493,3.801,81.746L120.26,294.396z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      enableBackground: "new"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.26,294.396c-2.976-2.284-0.118-23.586-1.649-44.542c-2.329-31.895,2.677-42.287,5.029-43.28 c4.337-0.753,6.049-1.044,10.449-1.156c6.441-0.233,12.889-0.094,19.314,0.417c4.398,0.542,8.748,1.427,13.008,2.648 c0,0,10.524,33.493,3.801,81.746L120.26,294.396z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M136.466,183.766c1.087,6.238,2.057,17.645-2.377,21.7c0,0,4.821,5.953,14.008,6.358 c7.964,0.351,5.306-5.941,5.306-5.941c-6.897-1.804-6.606-6.946-5.297-11.747L136.466,183.766z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M141.21,187.995l6.887,6.141c-0.32,1.117-0.544,2.259-0.669,3.414 c-2.639-0.436-6.208-3.424-6.431-6.199C140.859,190.229,140.932,189.091,141.21,187.995z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M158.808,175.464c0,0,6.329,1.334,7.202-2.617c0.873-3.951-0.696-4.628,1.177-6.529 c1.873-1.901,0.674-8.391-4.174-7.112c-4.848,1.278-7.397-5.384-11.41-4.475c-4.014,0.909-4.642,3.706-7.176,4.368 c-2.534,0.662-7.545-2.611-10.766-0.671c-3.221,1.939-0.736,6.102-1.827,7.688c-1.091,1.585-3.757,5.643,0,11.582 c3.441,5.438-0.838,8.176-3.067,7.667c-0.335-0.076-0.656,0.17-0.625,0.512c0.057,0.629,0.431,1.52,1.934,2.083 c2.525,0.946,3.048-0.431,3.585,0.289c0.536,0.72,1.844,3.095,5.947,0.665C143.71,186.484,145.85,171.109,158.808,175.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M158.901,184.442c-0.723,4.161-3.846,12.88-12.671,10.22c-8.826-2.66-9.206-9.624-9.354-11.635 c-0.148-2.011,1.724-17.619,7.371-19.101c5.647-1.482,12.499,0.349,14.654,3.575 C161.056,170.728,158.901,184.442,158.901,184.442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M148.712,178.063c-0.149,0.612,0.133,1.185,0.548,1.255c0.415,0.07,0.825-0.386,0.935-1.007 c0.11-0.622-0.143-1.188-0.548-1.255C149.242,176.987,148.825,177.431,148.712,178.063z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M155.688,179.269c-0.149,0.612,0.143,1.188,0.549,1.255c0.405,0.068,0.825-0.386,0.935-1.007 c0.11-0.622-0.143-1.188-0.548-1.255C156.217,178.194,155.791,178.676,155.688,179.269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DC5753"
    },
    d: "M153.48,179.193c0.418,2.038,1.115,4.009,2.073,5.857c-0.975,0.473-2.11,0.49-3.099,0.048 L153.48,179.193z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M151.408,174.155c-0.124-0.064-0.272-0.057-0.389,0.018c-0.775,0.544-1.761,0.691-2.66,0.396 c-0.188-0.081-0.405,0.006-0.486,0.193c-0.081,0.188,0.006,0.405,0.194,0.486c0,0,0.001,0,0.002,0.001 c1.127,0.402,2.38,0.233,3.36-0.455c0.173-0.109,0.226-0.337,0.118-0.51c-0.002-0.003-0.003-0.005-0.005-0.008 C151.503,174.23,151.458,174.188,151.408,174.155z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M147.899,187.784L147.899,187.784c1.761-0.607,3.707-0.316,5.214,0.778 c0.083,0.07,0.095,0.193,0.027,0.278c-0.063,0.083-0.183,0.1-0.266,0.036c-0.004-0.003-0.008-0.006-0.011-0.009 c-1.415-0.983-3.21-1.242-4.844-0.7c-0.098,0.036-0.208-0.014-0.244-0.112c-0.002-0.007-0.005-0.013-0.006-0.02 c-0.037-0.098,0.014-0.208,0.112-0.244C147.886,187.787,147.892,187.785,147.899,187.784z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.62,174.592c-0.068-0.033-0.144-0.044-0.218-0.031c-0.191,0.073-0.287,0.286-0.214,0.477 c0.001,0.003,0.002,0.005,0.003,0.008c0.419,1.125,1.36,1.976,2.522,2.281c0.2,0.04,0.395-0.09,0.435-0.29c0,0,0-0.001,0-0.001 c0.035-0.2-0.093-0.392-0.291-0.436l0,0c-0.91-0.267-1.64-0.949-1.969-1.838C156.828,174.669,156.73,174.607,156.62,174.592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M163.101,167.154c1.843,2.168-4.142,5.228-6.475,3.57c-2.031-1.444-4.175-3.106-6.819-1.52 c-2.644,1.586-2.886,0.193-4.704,0.193c-1.818,0,0.72,3.909-1.796,5.623c-1.436,0.978-3.504,1.491-2.854,3.236 c0.65,1.745-0.325,4.191-2.827,3.745c0,0,2.348-0.66,0.88-3.05c-1.467-2.39-2.718-1.047-2.718-1.047s0.7-13.174,6.947-15.597 C148.982,159.882,160.058,163.575,163.101,167.154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2877B"
    },
    d: "M139.26,178.949c0,0-1.576-4.365-5.611-4.383c-3.245-0.015-3.713,4.045-2.235,6.849 c1.132,2.15,4.642,4.661,7.199,2.023C140.124,181.879,139.26,178.949,139.26,178.949z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9B076"
    },
    d: "M150.712,256.292c0,0,27.68,8.725,29.269,9.096c1.589,0.37,9.353-1.086,10.783-0.77 c1.429,0.316,3.165,7.397,3.156,8.931c-0.01,1.534-12.106,1.515-13.125,0.997c-1.019-0.518-3.086-2.519-3.086-2.519 l-29.251-5.938L150.712,256.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M123.64,206.574c-15.582,1.431-4.062,46.688,2.257,53.21c6.319,6.523,27.99,8.858,27.99,8.858 l2.75-12.17c0,0-16.302-4.352-19.2-6.232c-2.898-1.881-4.912-20.65-6.64-29.777S123.64,206.574,123.64,206.574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6
    },
    d: "M123.64,206.574c-15.582,1.431-4.062,46.688,2.257,53.21c6.319,6.523,27.99,8.858,27.99,8.858 l2.75-12.17c0,0-16.302-4.352-19.2-6.232c-2.898-1.881-4.912-20.65-6.64-29.777S123.64,206.574,123.64,206.574z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "166.268,395.783 183.898,396.943 185.408,389.393 166.038,388.493  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "187.217,388.402 204.218,393.209 207.268,386.139 188.51,381.224  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M196.206,400.542l-8.685-2.424c-0.299-0.098-0.621,0.065-0.719,0.364 c-0.001,0.003-0.002,0.006-0.003,0.009l-2.343,6.76c-0.209,0.749,0.223,1.527,0.97,1.745c3.044,0.796,4.538,1.025,8.368,2.061 c2.348,0.648,6.926,2.152,10.274,2.533c3.349,0.381,3.635-2.939,2.252-3.395c-3.279-1.098-7.202-4.515-8.906-6.836 C197.112,400.961,196.688,400.673,196.206,400.542z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M177.782,406.765c0,0.008,0.166,0.012,0.168,0.021c0.009,0.03,0.179,0.056,0.202,0.076 c0.014,0.018,0.015,0.043,0.034,0.056c0.023,0.007,0.046,0.002,0.068-0.006c0.681,0.213,1.382,0.353,2.093,0.415 c0.53,0.095,1.074-0.012,1.529-0.301c0.289-0.257,0.401-0.658,0.292-1.029c-0.028-0.242-0.184-0.453-0.403-0.558 c-0.516-0.236-1.442,0.06-2.226,0.41c0.495-0.615,0.862-1.339,0.791-1.836c-0.05-0.326-0.354-0.577-0.683-0.608 c-0.289-0.053-0.665,0.023-0.893,0.21c-0.837,0.723-0.972,2.994-0.972,3.134c0,0.002,0,0.004,0,0.006c0,0.001,0,0.002,0,0.002 C177.782,406.758,177.782,406.765,177.782,406.765z M178.645,406.3c-0.061,0.034-0.113,0.063-0.165,0.092 c0.031-0.761,0.174-2.031,0.678-2.457c0.11-0.103,0.259-0.156,0.409-0.145l0.091,0.012c0.265,0.048,0.327,0.183,0.336,0.293 C180.041,404.638,179.327,405.711,178.645,406.3z M178.76,406.698c0.969-0.534,2.344-1.122,2.855-0.884 c0.109,0.051,0.182,0.155,0.194,0.275c0.061,0.234-0.005,0.484-0.175,0.657C181.232,407.091,180.177,407.07,178.76,406.698z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M177.589,405.784l-9-0.561c-0.313-0.034-0.594,0.193-0.628,0.506 c0,0.003-0.001,0.006-0.001,0.009l-0.883,7.1c-0.048,0.776,0.536,1.447,1.312,1.504c3.143,0.145,4.651,0.057,8.614,0.273 c2.431,0.145,7.222,0.662,10.576,0.337c3.355-0.325,2.943-3.632,1.495-3.79c-3.435-0.391-7.985-2.915-10.135-4.831 C178.563,406.005,178.087,405.812,177.589,405.784z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "155.058,221.733 167.49,220.57 168.122,223.798  155.819,225.52  "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M212.043,265.649H85.286c-1.194,0-2.162-0.968-2.162-2.162v-5.514h131.081v5.513 C214.206,264.681,213.237,265.649,212.043,265.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M212.043,265.649H85.286 c-1.194,0-2.162-0.968-2.162-2.162v-5.514h131.081v5.513C214.206,264.681,213.237,265.649,212.043,265.649z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.124,
    y: 257.973,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 131.081,
    height: 3.838
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M218.003,258.974H79.327c-1.194,0-2.162-0.968-2.162-2.162l0,0c0-1.194,0.968-2.162,2.162-2.162 h138.676c1.194,0,2.162,0.968,2.162,2.162l0,0C220.165,258.006,219.197,258.974,218.003,258.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M218.003,258.974H79.327 c-1.194,0-2.162-0.968-2.162-2.162l0,0c0-1.194,0.968-2.162,2.162-2.162h138.676c1.194,0,2.162,0.968,2.162,2.162l0,0 C220.165,258.006,219.197,258.974,218.003,258.974z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 86.351,
    y: 265.649,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 229.39 680.707)",
    style: {
      fill: "#263238"
    },
    width: 56.687,
    height: 149.409
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.351,
    y: 265.649,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 229.39 680.707)",
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 56.687,
    height: 149.409
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 143.039,
    y: 265.649,
    style: {
      fill: "#263238"
    },
    width: 116.539,
    height: 149.409
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.039,
    y: 265.649,
    style: {
      opacity: 0.39,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 116.539,
    height: 149.409
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M259.578,265.649H142.821c-1.194,0-2.162-0.968-2.162-2.162v-5.514H261.74v5.513 C261.74,264.681,260.772,265.649,259.578,265.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M259.578,265.649H142.821 c-1.194,0-2.162-0.968-2.162-2.162v-5.514H261.74v5.513C261.74,264.681,260.772,265.649,259.578,265.649z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 140.658,
    y: 257.973,
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    width: 121.081,
    height: 3.838
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265.537,258.974H136.861c-1.194,0-2.162-0.968-2.162-2.162l0,0 c0-1.194,0.968-2.162,2.162-2.162h128.676c1.194,0,2.162,0.968,2.162,2.162l0,0 C267.699,258.006,266.731,258.974,265.537,258.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M265.537,258.974H136.861 c-1.194,0-2.162-0.968-2.162-2.162l0,0c0-1.194,0.968-2.162,2.162-2.162h128.676c1.194,0,2.162,0.968,2.162,2.162l0,0 C267.699,258.006,266.731,258.974,265.537,258.974z"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M237.74,398.378h-73.083v-120.64h73.083V398.378z M171.106,391.929h60.186V284.186h-60.186 V391.929z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.391,
    y: 297.918,
    style: {
      fill: "#FFFFFF"
    },
    width: 37.616,
    height: 80.28
  })))), /*#__PURE__*/React.createElement("g", {
    id: "_Police_badges"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M251.341,242.173h-43.6c-2.121,0-3.841-1.72-3.841-3.841 v-30.574c0-2.121,1.72-3.841,3.841-3.841h43.6c2.121,0,3.841,1.72,3.841,3.841v30.574 C255.182,240.453,253.463,242.173,251.341,242.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M248.456,219.176c0,0,14.279,10.276,31.915-3.559 c0,0-16.007,22.829-37.263,11.887L248.456,219.176z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 214.413,
    y: 201.404,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 452.5859 -6.496)",
    style: {
      opacity: 0.39,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    width: 30.256,
    height: 43.282
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M228.844,235.558c-0.926-0.959-2.267-1.572-3.663-2.251 c-3.526-1.333-6.053-4.299-6.359-8.216c-0.117-1.496,0.098-2.847,0.769-4.212c0.305-0.621,0.719-1.16,1.066-1.751 c0.637-1.086,0.68-2.463-0.009-3.624c-0.118-0.199-0.263-0.382-0.38-0.58c-0.277-0.466-0.253-1.02,0.014-1.451 c0.082-0.133,0.182-0.237,0.293-0.345l1.164-1.139c0.126-0.124,0.251-0.242,0.409-0.331c0.386-0.217,0.832-0.244,1.222-0.111 c0.145,0.05,0.275,0.128,0.42,0.181c1.77,0.648,4.003,0.08,5.245-1.262c0.251-0.271,0.737-0.302,0.992-0.02 c1.249,1.382,3.524,1.945,5.268,1.282c0.144-0.055,0.274-0.131,0.42-0.181c0.39-0.133,0.836-0.106,1.222,0.111 c0.158,0.089,0.284,0.206,0.41,0.331l1.164,1.139c0.11,0.108,0.21,0.211,0.292,0.345c0.266,0.431,0.29,0.985,0.014,1.451 c-0.117,0.198-0.262,0.381-0.38,0.58c-0.689,1.161-0.645,2.537-0.009,3.624c0.347,0.591,0.761,1.13,1.066,1.751 c0.671,1.365,0.886,2.716,0.769,4.212c-0.307,3.917-2.834,6.883-6.36,8.216c-1.382,0.672-2.71,1.28-3.635,2.222 C229.885,235.918,229.233,235.962,228.844,235.558L228.844,235.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M228.844,235.558c-0.926-0.959-2.267-1.572-3.663-2.251 c-3.526-1.333-6.053-4.299-6.359-8.216c-0.117-1.496,0.098-2.847,0.769-4.212c0.305-0.621,0.719-1.16,1.066-1.751 c0.637-1.086,0.68-2.463-0.009-3.624c-0.118-0.199-0.263-0.382-0.38-0.58c-0.277-0.466-0.253-1.02,0.014-1.451 c0.082-0.133,0.182-0.237,0.293-0.345l1.164-1.139c0.126-0.124,0.251-0.242,0.409-0.331c0.386-0.217,0.832-0.244,1.222-0.111 c0.145,0.05,0.275,0.128,0.42,0.181c1.77,0.648,4.003,0.08,5.245-1.262c0.251-0.271,0.737-0.302,0.992-0.02 c1.249,1.382,3.524,1.945,5.268,1.282c0.144-0.055,0.274-0.131,0.42-0.181c0.39-0.133,0.836-0.106,1.222,0.111 c0.158,0.089,0.284,0.206,0.41,0.331l1.164,1.139c0.11,0.108,0.21,0.211,0.292,0.345c0.266,0.431,0.29,0.985,0.014,1.451 c-0.117,0.198-0.262,0.381-0.38,0.58c-0.689,1.161-0.645,2.537-0.009,3.624c0.347,0.591,0.761,1.13,1.066,1.751 c0.671,1.365,0.886,2.716,0.769,4.212c-0.307,3.917-2.834,6.883-6.36,8.216c-1.382,0.672-2.71,1.28-3.635,2.222 C229.885,235.918,229.233,235.962,228.844,235.558L228.844,235.558z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M229.541,232.044c0.462-0.304,0.951-0.584,1.454-0.846 c0.814-0.423,1.675-0.742,2.487-1.159c0.966-0.496,1.827-1.18,2.452-2.06c0.363-0.51,0.638-1.072,0.829-1.664 c0.298-0.924,0.387-1.919,0.222-2.852c-0.135-0.763-0.555-1.456-0.977-2.15c-0.599-0.988-1.057-1.876-1.227-2.998 c-0.167-1.105-0.049-2.246,0.342-3.294c-0.332,0.059-0.667,0.096-1,0.113c-1.594,0.079-3.22-0.31-4.595-1.088 c-0.471,0.262-0.968,0.478-1.481,0.648c-1.306,0.431-2.725,0.555-4.083,0.32c0.453,1.222,0.537,2.579,0.234,3.846 c-0.213,0.888-0.652,1.621-1.092,2.354c-0.509,0.849-0.972,1.694-1.061,2.675c-0.107,1.18,0.149,2.397,0.711,3.448 c0.42,0.786,1.007,1.462,1.718,2.006c0.541,0.413,1.163,0.697,1.781,0.982c0.604,0.278,1.215,0.561,1.841,0.884 C228.594,231.469,229.079,231.743,229.541,232.044L229.541,232.044z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M231.549,232.209c-0.237,0.123-0.469,0.253-0.697,0.388 c-0.813,0.482-1.807,0.484-2.623,0.005c-0.225-0.132-0.453-0.259-0.687-0.38c-0.567-0.294-1.181-0.577-1.79-0.857 c-0.698-0.321-1.397-0.651-2.007-1.117c-0.842-0.644-1.538-1.446-2.036-2.379c-0.095-0.177-0.184-0.364-0.268-0.56 c-0.471-1.099-0.68-2.329-0.573-3.517c0.104-1.149,0.622-2.157,1.218-3.152c0.395-0.658,0.789-1.317,0.963-2.04 c0.227-0.95,0.192-1.966-0.096-2.905c-0.111-0.362-0.26-0.714-0.447-1.046l-0.001-0.002l-0.213-0.375 c0.236-0.231,0.473-0.462,0.709-0.693l0.343,0.108c1.393,0.438,2.93,0.382,4.326-0.078c0.289-0.095,0.564-0.21,0.831-0.338 c0.676-0.325,1.456-0.288,2.137,0.027c1.063,0.492,2.192,0.754,3.428,0.693c0.705-0.035,1.358-0.2,2.021-0.409 c0.236,0.23,0.471,0.462,0.707,0.692c-0.249,0.451-0.492,0.902-0.648,1.392c-0.255,0.801-0.319,1.655-0.193,2.485 c0.147,0.975,0.551,1.717,1.075,2.58c0.477,0.786,0.953,1.57,1.124,2.54c0.197,1.114,0.093,2.295-0.259,3.386 c-0.225,0.698-0.556,1.367-0.984,1.97c-0.732,1.03-1.741,1.846-2.874,2.428C233.22,231.472,232.363,231.786,231.549,232.209 L231.549,232.209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M229.541,219.531c2.384,0,4.317,1.933,4.317,4.317 c0,2.384-1.933,4.317-4.317,4.317s-4.317-1.933-4.317-4.317C225.224,221.465,227.157,219.531,229.541,219.531L229.541,219.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    d: "M229.541,219.531c2.384,0,4.317,1.933,4.317,4.317 c0,2.384-1.933,4.317-4.317,4.317s-4.317-1.933-4.317-4.317C225.224,221.465,227.157,219.531,229.541,219.531L229.541,219.531z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Hammer_of_law"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M454.387,229.332h-49.732c-2.42,0-4.381-1.962-4.381-4.381 v-34.873c0-2.42,1.962-4.381,4.381-4.381h49.732c2.42,0,4.381,1.962,4.381,4.381v34.873 C458.769,227.371,456.807,229.332,454.387,229.332z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M408.208,201.589c0,0-9.808,14.604-31.157,7.775 c0,0,22.954,15.828,39.07-1.829L408.208,201.589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M404.655,225.332 c-0.21,0-0.381-0.171-0.381-0.381v-34.873c0-0.21,0.171-0.381,0.381-0.381h49.732c0.21,0,0.381,0.171,0.381,0.381v34.873 c0,0.21-0.171,0.381-0.381,0.381H404.655z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M413.236,220.478L413.236,220.478c-1.192-0.288-2.138-1.194-2.477-2.372l-0.042-0.146 l15.162-15.162l2.519,2.519L413.236,220.478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M413.236,220.478L413.236,220.478c-1.192-0.288-2.138-1.194-2.477-2.372l-0.042-0.146 l15.162-15.162l2.519,2.519L413.236,220.478z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.821,
    y: 201.96,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 269.4445 -242.2064)",
    style: {
      fill: "#407BFF"
    },
    width: 4.502,
    height: 4.326
  }), /*#__PURE__*/React.createElement("rect", {
    x: 424.821,
    y: 201.96,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 269.4445 -242.2064)",
    style: {
      opacity: 0.7
    },
    width: 4.502,
    height: 4.326
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.094,
    y: 197.757,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 268.2736 -244.9945)",
    style: {
      fill: "#407BFF"
    },
    width: 13.542,
    height: 7.147
  }), /*#__PURE__*/React.createElement("rect", {
    x: 423.094,
    y: 197.757,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 268.2736 -244.9945)",
    style: {
      opacity: 0.3
    },
    width: 13.542,
    height: 7.147
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M422.661,200.377l-1.499-1.498c-0.391-0.391-0.391-1.024,0-1.414l4.837-4.837 c0.391-0.391,1.024-0.391,1.414,0l1.498,1.499c0.391,0.391,0.391,1.024,0,1.414l-4.837,4.837 C423.684,200.768,423.051,200.768,422.661,200.377z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M432.316,210.033l-1.499-1.498c-0.391-0.391-0.391-1.024,0-1.414l4.837-4.837 c0.391-0.391,1.024-0.391,1.414,0l1.499,1.499c0.39,0.391,0.39,1.024,0,1.414l-4.837,4.837 C433.34,210.424,432.707,210.424,432.316,210.033z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M422.661,200.377l-1.499-1.498c-0.391-0.391-0.391-1.024,0-1.414l4.837-4.837c0.391-0.391,1.024-0.391,1.414,0 l1.498,1.499c0.391,0.391,0.391,1.024,0,1.414l-4.837,4.837C423.684,200.768,423.051,200.768,422.661,200.377z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M432.316,210.033l-1.499-1.498c-0.391-0.391-0.391-1.024,0-1.414l4.837-4.837c0.391-0.391,1.024-0.391,1.414,0 l1.499,1.499c0.39,0.391,0.39,1.024,0,1.414l-4.837,4.837C433.34,210.424,432.707,210.424,432.316,210.033z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M442.983,213.124h-12.806c-0.686,0-1.242,0.556-1.242,1.242v3.664h15.29v-3.664 C444.225,213.68,443.669,213.124,442.983,213.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M442.983,213.124h-12.806c-0.686,0-1.242,0.556-1.242,1.242v3.664h15.29v-3.664 C444.225,213.68,443.669,213.124,442.983,213.124z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M444.544,217.796h-15.929c-0.727,0-1.316,0.589-1.316,1.316l0,0c0,0.727,0.589,1.316,1.316,1.316 h15.929c0.727,0,1.316-0.589,1.316-1.316l0,0C445.86,218.385,445.271,217.796,444.544,217.796z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M444.544,217.796h-15.929c-0.727,0-1.316,0.589-1.316,1.316l0,0c0,0.727,0.589,1.316,1.316,1.316 h15.929c0.727,0,1.316-0.589,1.316-1.316l0,0C445.86,218.385,445.271,217.796,444.544,217.796z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Legal_balance"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M236.8,147.622h-67.205c-3.27,0-5.921-2.651-5.921-5.921 V94.576c0-3.27,2.651-5.921,5.921-5.921H236.8c3.27,0,5.921,2.651,5.921,5.921v47.126 C242.721,144.971,240.07,147.622,236.8,147.622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M230.788,136.52c0,0-1.642,17.516,19.212,25.731 c0,0-27.79-2.262-29.102-26.132L230.788,136.52z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M169.595,143.622 c-1.059,0-1.921-0.861-1.921-1.92V94.576c0-1.059,0.862-1.921,1.921-1.921H236.8c1.059,0,1.92,0.862,1.92,1.921v47.126 c0,1.059-0.861,1.92-1.92,1.92H169.595z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M194.705,119.283c-0.873,2.281-3.085,3.898-5.679,3.898c-2.59,0-4.802-1.617-5.679-3.898 H194.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M194.705,119.283c-0.873,2.281-3.085,3.898-5.679,3.898c-2.59,0-4.802-1.617-5.679-3.898H194.705 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M194.705,118.48c-0.074,0-0.144-0.039-0.181-0.11l-5.498-10.486l-5.497,10.486 c-0.053,0.1-0.178,0.139-0.277,0.087c-0.1-0.053-0.139-0.177-0.087-0.277l5.679-10.833c0.072-0.135,0.293-0.135,0.364,0 l5.679,10.833c0.053,0.101,0.014,0.225-0.086,0.277C194.77,118.473,194.737,118.48,194.705,118.48z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M194.705,118.48c-0.074,0-0.144-0.039-0.181-0.11l-5.498-10.486l-5.497,10.486c-0.053,0.1-0.178,0.139-0.277,0.087 c-0.1-0.053-0.139-0.177-0.087-0.277l5.679-10.833c0.072-0.135,0.293-0.135,0.364,0l5.679,10.833 c0.053,0.101,0.014,0.225-0.086,0.277C194.77,118.473,194.737,118.48,194.705,118.48z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M189.026,118.984c-0.113,0-0.205-0.092-0.205-0.205v-11.337c0-0.114,0.092-0.205,0.205-0.205 c0.113,0,0.206,0.091,0.206,0.205v11.337C189.231,118.892,189.139,118.984,189.026,118.984z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.026,118.984c-0.113,0-0.205-0.092-0.205-0.205v-11.337c0-0.114,0.092-0.205,0.205-0.205 c0.113,0,0.206,0.091,0.206,0.205v11.337C189.231,118.892,189.139,118.984,189.026,118.984z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 182.537,
    y: 118.275,
    style: {
      fill: "#407BFF"
    },
    width: 12.978,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.537,
    y: 118.275,
    style: {
      opacity: 0.3
    },
    width: 12.978,
    height: 1.008
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M222.798,119.283c-0.873,2.281-3.085,3.898-5.679,3.898c-2.59,0-4.802-1.617-5.679-3.898 H222.798z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M222.798,119.283c-0.873,2.281-3.085,3.898-5.679,3.898c-2.59,0-4.802-1.617-5.679-3.898H222.798 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M222.798,118.48c-0.074,0-0.145-0.039-0.181-0.11l-5.498-10.486l-5.498,10.486 c-0.052,0.1-0.177,0.139-0.276,0.087c-0.101-0.053-0.139-0.177-0.087-0.277l5.679-10.833c0.072-0.135,0.293-0.135,0.363,0 l5.68,10.833c0.052,0.101,0.014,0.225-0.087,0.277C222.863,118.473,222.831,118.48,222.798,118.48z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M222.798,118.48c-0.074,0-0.145-0.039-0.181-0.11l-5.498-10.486l-5.498,10.486c-0.052,0.1-0.177,0.139-0.276,0.087 c-0.101-0.053-0.139-0.177-0.087-0.277l5.679-10.833c0.072-0.135,0.293-0.135,0.363,0l5.68,10.833 c0.052,0.101,0.014,0.225-0.087,0.277C222.863,118.473,222.831,118.48,222.798,118.48z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M217.119,118.984c-0.113,0-0.205-0.092-0.205-0.205v-11.337c0-0.114,0.092-0.205,0.205-0.205 c0.114,0,0.205,0.091,0.205,0.205v11.337C217.324,118.892,217.233,118.984,217.119,118.984z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217.119,118.984c-0.113,0-0.205-0.092-0.205-0.205v-11.337c0-0.114,0.092-0.205,0.205-0.205 c0.114,0,0.205,0.091,0.205,0.205v11.337C217.324,118.892,217.233,118.984,217.119,118.984z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 210.63,
    y: 118.275,
    style: {
      fill: "#407BFF"
    },
    width: 12.979,
    height: 1.008
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.63,
    y: 118.275,
    style: {
      opacity: 0.3
    },
    width: 12.979,
    height: 1.008
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M203.012,103.987v2.093c-2.12,0.042-4.521,1.202-6.433,2.256 c-1.377,0.759-3.003,1.015-4.08,0.908c-1.587-0.157-3.165-0.936-4.72-1.916v-1.169c1.555,0.979,2.863,1.554,4.632,1.617 c1.578,0.056,2.861-0.725,4.169-1.533C198.454,105.094,200.892,104.029,203.012,103.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M203.012,103.987v2.093c-2.12,0.042-4.521,1.202-6.433,2.256c-1.377,0.759-3.003,1.015-4.08,0.908 c-1.587-0.157-3.165-0.936-4.72-1.916v-1.169c1.555,0.979,2.863,1.554,4.632,1.617c1.578,0.056,2.861-0.725,4.169-1.533 C198.454,105.094,200.892,104.029,203.012,103.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M189.026,106.627c0,0.659-0.534,1.193-1.193,1.193c-0.659,0-1.192-0.534-1.192-1.193 c0-0.659,0.533-1.193,1.192-1.193C188.492,105.435,189.026,105.968,189.026,106.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M189.026,106.627c0,0.659-0.534,1.193-1.193,1.193c-0.659,0-1.192-0.534-1.192-1.193 c0-0.659,0.533-1.193,1.192-1.193C188.492,105.435,189.026,105.968,189.026,106.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M203.012,103.987v2.093c2.121,0.042,4.521,1.202,6.433,2.256 c1.378,0.759,3.004,1.015,4.082,0.908c1.587-0.157,3.164-0.936,4.719-1.916v-1.169c-1.555,0.979-2.863,1.554-4.632,1.617 c-1.578,0.056-2.861-0.725-4.17-1.533C207.573,105.094,205.133,104.029,203.012,103.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M203.012,103.987v2.093c2.121,0.042,4.521,1.202,6.433,2.256c1.378,0.759,3.004,1.015,4.082,0.908 c1.587-0.157,3.164-0.936,4.719-1.916v-1.169c-1.555,0.979-2.863,1.554-4.632,1.617c-1.578,0.056-2.861-0.725-4.17-1.533 C207.573,105.094,205.133,104.029,203.012,103.987z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M217.119,106.627c0,0.659,0.535,1.193,1.193,1.193s1.193-0.534,1.193-1.193 c0-0.659-0.534-1.193-1.193-1.193S217.119,105.968,217.119,106.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M217.119,106.627c0,0.659,0.535,1.193,1.193,1.193s1.193-0.534,1.193-1.193 c0-0.659-0.534-1.193-1.193-1.193S217.119,105.968,217.119,106.627z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.499,
    y: 100.358,
    style: {
      fill: "#407BFF"
    },
    width: 3.027,
    height: 31.004
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.499,
    y: 100.358,
    style: {
      opacity: 0.7
    },
    width: 3.027,
    height: 31.004
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M205.58,105.418c0,1.418-1.15,2.567-2.568,2.567c-1.417,0-2.566-1.15-2.566-2.567 c0-1.418,1.149-2.567,2.566-2.567C204.431,102.85,205.58,104,205.58,105.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M205.58,105.418c0,1.418-1.15,2.567-2.568,2.567c-1.417,0-2.566-1.15-2.566-2.567 c0-1.418,1.149-2.567,2.566-2.567C204.431,102.85,205.58,104,205.58,105.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M204.973,98.553c0,1.082-0.878,1.96-1.96,1.96c-1.082,0-1.959-0.877-1.959-1.96 c0-1.082,0.877-1.959,1.959-1.959C204.095,96.593,204.973,97.47,204.973,98.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M204.973,98.553c0,1.082-0.878,1.96-1.96,1.96c-1.082,0-1.959-0.877-1.959-1.96 c0-1.082,0.877-1.959,1.959-1.959C204.095,96.593,204.973,97.47,204.973,98.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M211.322,135.991h-16.62v-3.63c0-0.552,0.448-1,1-1h14.62c0.552,0,1,0.448,1,1V135.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M211.322,135.991h-16.62v-3.63c0-0.552,0.448-1,1-1h14.62c0.552,0,1,0.448,1,1V135.991z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M216.368,139.434h-26.711c-0.951,0-1.721-0.771-1.721-1.721l0,0c0-0.951,0.771-1.721,1.721-1.721 h26.711c0.951,0,1.721,0.771,1.721,1.721l0,0C218.089,138.663,217.319,139.434,216.368,139.434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M216.368,139.434h-26.711c-0.951,0-1.721-0.771-1.721-1.721l0,0c0-0.951,0.771-1.721,1.721-1.721 h26.711c0.951,0,1.721,0.771,1.721,1.721l0,0C218.089,138.663,217.319,139.434,216.368,139.434z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.702,
    y: 132.548,
    style: {
      fill: "#407BFF"
    },
    width: 16.62,
    height: 1.128
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.702,
    y: 132.548,
    style: {
      opacity: 0.5
    },
    width: 16.62,
    height: 1.128
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M205.29,100.512c0,0.46-0.373,0.834-0.833,0.834h-2.888c-0.461,0-0.834-0.373-0.834-0.834l0,0 c0-0.461,0.374-0.834,0.834-0.834h2.888C204.917,99.678,205.29,100.051,205.29,100.512L205.29,100.512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M205.29,100.512c0,0.46-0.373,0.834-0.833,0.834h-2.888c-0.461,0-0.834-0.373-0.834-0.834l0,0 c0-0.461,0.374-0.834,0.834-0.834h2.888C204.917,99.678,205.29,100.051,205.29,100.512L205.29,100.512z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Paper"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M439.764,139.463h-57.907c-2.817,0-5.101-2.284-5.101-5.102 V93.756c0-2.817,2.284-5.102,5.101-5.102h57.907c2.817,0,5.102,2.284,5.102,5.102v40.605 C444.865,137.179,442.581,139.463,439.764,139.463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#407BFF"
    },
    d: "M390.384,131.983c0,0,1.642,17.516-19.212,25.731 c0,0,27.79-2.262,29.102-26.132L390.384,131.983z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.39,
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M381.856,135.463 c-0.607,0-1.101-0.494-1.101-1.102V93.756c0-0.607,0.494-1.102,1.101-1.102h57.907c0.607,0,1.102,0.494,1.102,1.102v40.605 c0,0.607-0.494,1.102-1.102,1.102H381.856z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M422.396,97.011L422.396,97.011c1.38,0,2.499,1.119,2.499,2.499v1.199h-6.819L422.396,97.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.7
    },
    d: "M422.396,97.011L422.396,97.011c1.38,0,2.499,1.119,2.499,2.499v1.199h-6.819L422.396,97.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M423.489,129.973c4.91-9.742-4.921-24.069-1.093-32.962h-20.87c-1.983,0-3.617,1.524-3.794,3.498 c-0.815,9.069,6.617,21.547,1.578,30.123h23.069C422.841,130.633,423.281,130.385,423.489,129.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3
    },
    d: "M423.489,129.973c4.91-9.742-4.921-24.069-1.093-32.962h-20.87c-1.983,0-3.617,1.524-3.794,3.498 c-0.815,9.069,6.617,21.547,1.578,30.123h23.069C422.841,130.633,423.281,130.385,423.489,129.973z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#407BFF"
    },
    d: "M399.31,130.633L399.31,130.633c-1.211,0-2.192-0.982-2.192-2.192v-0.817h23.191v0.817 c0,1.211,0.982,2.192,2.192,2.192h0.629H399.31z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5
    },
    d: "M399.31,130.633L399.31,130.633c-1.211,0-2.192-0.982-2.192-2.192v-0.817h23.191v0.817 c0,1.211,0.982,2.192,2.192,2.192h0.629H399.31z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.944,
    y: 101.651,
    style: {
      opacity: 0.3
    },
    width: 16.428,
    height: 1.366
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.708,
    y: 106.486,
    style: {
      opacity: 0.3
    },
    width: 16.428,
    height: 1.366
  }), /*#__PURE__*/React.createElement("rect", {
    x: 402.596,
    y: 110.151,
    style: {
      opacity: 0.3
    },
    width: 16.428,
    height: 1.366
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.48,
    y: 113.815,
    style: {
      opacity: 0.3
    },
    width: 16.428,
    height: 1.366
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.3
    },
    cx: 418.076,
    cy: 122.216,
    r: 2.535
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService7);
export default __webpack_public_path__ + "static/media/service7.c22dca9745e13a3f9d66fd35b5b55ba2.svg";
export { ForwardRef as ReactComponent };